"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AXSSwitch = void 0;
var AXSFlex_1 = __importDefault(require("../../layout/AXSFlex"));
var utils_1 = require("../../utils");
var colors_1 = require("../../constants/colors");
var AXSFlexItem_1 = __importDefault(require("../../layout/AXSFlexItem"));
var AXSIcon_1 = __importDefault(require("../../elements/AXSIcon"));
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var SwitchContainer = styled_components_1.default(AXSFlex_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  margin: 16px 0;\n\n  &:hover {\n    cursor: pointer;\n\n    .toggle-btn {\n      border: ", ";\n    }\n  }\n"], ["\n  position: relative;\n  margin: 16px 0;\n\n  &:hover {\n    cursor: pointer;\n\n    .toggle-btn {\n      border: ",
    ";\n    }\n  }\n"])), function (_a) {
    var toggleBorderColorHover = _a.toggleBorderColorHover, theme = _a.theme, disabled = _a.disabled, type = _a.type;
    return type === 'switch' ? 'none' :
        disabled ? "2px solid " + utils_1.parseThemePath(toggleBorderColorHover, theme, colors_1.colors.GREY_175) :
            "2px solid " + utils_1.parseThemePath(toggleBorderColorHover, theme, colors_1.colors.BLUE_300);
});
var SwitchButton = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  outline: 0;\n  opacity: ", ";\n  width: ", ";\n  height: ", ";\n  position: relative;\n  cursor: pointer;\n  user-select: none;\n  background: ", ";\n  border-radius: ", ";\n  padding: ", ";\n  transition: ", ";\n  border: ", ";\n\n  &:hover {\n    border: ", ";\n  }\n\n  &:after {\n    background-color: ", ";\n    left: ", ";\n    top: ", ";\n    position: relative;\n    display: block;\n    content: '';\n    width: ", ";\n    height: ", ";\n    border-radius: ", ";\n    transition: ", ";\n  }\n"], ["\n  display: inline-block;\n  outline: 0;\n  opacity: ", ";\n  width: ",
    ";\n  height: ", ";\n  position: relative;\n  cursor: pointer;\n  user-select: none;\n  background: ",
    ";\n  border-radius: ",
    ";\n  padding: ",
    ";\n  transition: ", ";\n  border: ",
    ";\n\n  &:hover {\n    border: ",
    ";\n  }\n\n  &:after {\n    background-color: ",
    ";\n    left: ",
    ";\n    top: ", ";\n    position: relative;\n    display: block;\n    content: '';\n    width: ", ";\n    height: ", ";\n    border-radius: ", ";\n    transition: ",
    ";\n  }\n"])), function (_a) {
    var disable = _a.disable;
    return (disable ? '0.5' : 1);
}, function (_a) {
    var type = _a.type;
    return type === 'switch' ? '30px' : type === 'check' ? '18px' : '20px';
}, function (_a) {
    var type = _a.type;
    return (type === 'check' ? '18px' : type === 'switch' ? '14px' : '20px');
}, function (_a) {
    var type = _a.type, enabled = _a.enabled, toggleCheckBackgroundColor = _a.toggleCheckBackgroundColor, toggleBorderColor = _a.toggleBorderColor, theme = _a.theme;
    return type === 'switch' ? enabled ? utils_1.parseThemePath(toggleCheckBackgroundColor, theme, colors_1.colors.BLUE_300) :
        utils_1.parseThemePath(toggleBorderColor, theme, colors_1.colors.BLUE_300) :
        type === 'check' && enabled ? utils_1.parseThemePath(toggleCheckBackgroundColor, theme, colors_1.colors.BLUE_300) : 'transparent';
}, function (_a) {
    var type = _a.type;
    return type === 'switch' ? '8px' : type === 'check' ? '0' : '100%';
}, function (_a) {
    var type = _a.type;
    return type === 'radio' ? '2px 2px' : type === 'switch' ? '0 2px' : 0;
}, function (_a) {
    var type = _a.type;
    return (type === 'switch' ? 'all 0.4s ease' : 'none');
}, function (_a) {
    var toggleBorderColor = _a.toggleBorderColor, toggleCheckBackgroundColor = _a.toggleCheckBackgroundColor, enabled = _a.enabled, theme = _a.theme, color = _a.color, disabled = _a.disabled, type = _a.type;
    return type === 'switch' ? 'none' : enabled ? "2px solid " + utils_1.parseThemePath(toggleCheckBackgroundColor, theme, colors_1.colors.BLUE_300) : disabled ? "2px solid " + utils_1.parseThemePath(toggleBorderColor, theme, colors_1.colors.GREY_175) : "2px solid " + utils_1.parseThemePath(toggleBorderColor, theme, '#9c9c9c');
}, function (_a) {
    var toggleBorderColorHover = _a.toggleBorderColorHover, enabled = _a.enabled, theme = _a.theme, color = _a.color, disabled = _a.disabled, type = _a.type;
    return type === 'switch' ? 'none' :
        enabled
            ? "2px solid " + utils_1.parseThemePath(toggleBorderColorHover, theme, colors_1.colors.BLUE_300)
            : disabled ? "2px solid " + utils_1.parseThemePath(color, theme, colors_1.colors.GREY_175)
                : "2px solid " + utils_1.parseThemePath(toggleBorderColorHover, theme, '#9c9c9c');
}, function (_a) {
    var enabled = _a.enabled, theme = _a.theme, toggleCheckBackgroundColor = _a.toggleCheckBackgroundColor, type = _a.type;
    return enabled
        ? utils_1.parseThemePath(toggleCheckBackgroundColor, theme, colors_1.colors.BLUE_300)
        : type === 'switch'
            ? utils_1.parseThemePath(toggleCheckBackgroundColor, theme, colors_1.colors.BLUE_300)
            : 'transparent';
}, function (_a) {
    var enabled = _a.enabled, type = _a.type;
    return enabled && type === 'switch' ? '12px' : type === 'switch' ? '-6px' : '0';
}, function (_a) {
    var type = _a.type;
    return type === 'switch' ? '-3px' : '0';
}, function (_a) {
    var type = _a.type;
    return type === 'switch' ? '20px' : type === 'check' ? '14px ' : '12px';
}, function (_a) {
    var type = _a.type;
    return type === 'switch' ? '20px' : type === 'check' ? '14px ' : '12px';
}, function (_a) {
    var type = _a.type;
    return type === 'radio' || type === 'switch' ? '100%' : '0';
}, function (_a) {
    var type = _a.type;
    return type === 'switch'
        ? 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), padding 0.3s ease, margin 0.3s ease'
        : 'none';
});
var SwitchButtonContainer = styled_components_1.default(AXSFlexItem_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var Check = styled_components_1.default(AXSIcon_1.default)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  left: 1px;\n  line-height: 0;\n  font-size: 18px;\n  pointer-events: none;\n  position: absolute;\n  top: -2px;\n  z-index: 1;\n"], ["\n  left: 1px;\n  line-height: 0;\n  font-size: 18px;\n  pointer-events: none;\n  position: absolute;\n  top: -2px;\n  z-index: 1;\n"])));
var Input = styled_components_1.default.input(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: none;\n"], ["\n  display: none;\n"])));
var Label = styled_components_1.default.label(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: ", ";\n  opacity: ", ";\n  margin: ", ";\n  font-size: 13px;\n  font-family: 'Lato', sans-serif;\n\n  &:hover {\n    cursor: pointer;\n  }\n"], ["\n  color: ", ";\n  opacity: ", ";\n  margin: ", ";\n  font-size: 13px;\n  font-family: 'Lato', sans-serif;\n\n  &:hover {\n    cursor: pointer;\n  }\n"])), function (_a) {
    var labelColor = _a.labelColor, theme = _a.theme;
    return utils_1.parseThemePath(labelColor, theme, colors_1.colors.GREY_650);
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? '0.5' : 1);
}, function (_a) {
    var labelBefore = _a.labelBefore;
    return (labelBefore ? '0 8px 4px 0' : '0 0 4px 8px');
});
var AXSSwitch = /** @class */ (function (_super) {
    __extends(AXSSwitch, _super);
    function AXSSwitch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AXSSwitch.prototype.render = function () {
        var _a = this.props, enabled = _a.enabled, theme = _a.theme, label = _a.label, labelBefore = _a.labelBefore, labelColor = _a.labelColor, toggleBorderColor = _a.toggleBorderColor, toggleBorderColorHover = _a.toggleBorderColorHover, toggleCheckBackgroundColor = _a.toggleCheckBackgroundColor, toggleCheckColor = _a.toggleCheckColor, type = _a.type, disabled = _a.disabled, id = _a.id, props = __rest(_a, ["enabled", "theme", "label", "labelBefore", "labelColor", "toggleBorderColor", "toggleBorderColorHover", "toggleCheckBackgroundColor", "toggleCheckColor", "type", "disabled", "id"]);
        return (React.createElement(SwitchContainer, { alignItems: "center", toggleBorderColorHover: toggleBorderColorHover, toggleCheckBackgroundColor: toggleCheckBackgroundColor, theme: theme, disabled: disabled, type: type },
            React.createElement(Input, __assign({ className: "toggle-input", type: "check", checked: enabled, disabled: disabled, id: id ? id : label }, props)),
            label && labelBefore && (React.createElement(Label, { htmlFor: id ? id : label, labelBefore: labelBefore, labelColor: labelColor, disabled: disabled }, label)),
            React.createElement(SwitchButtonContainer, null,
                React.createElement(SwitchButton, __assign({ "aria-label": "Toggle", "aria-pressed": enabled, enabled: enabled, theme: theme, toggleBorderColor: toggleBorderColor, toggleBorderColorHover: toggleBorderColorHover, toggleCheckBackgroundColor: toggleCheckBackgroundColor, type: type }, this.props, { className: classnames_1.default([
                        'toggle-btn',
                        enabled ? 'toggle-btn-on' : 'toggle-btn-off',
                    ]) })),
                type === 'check' && enabled && (React.createElement(Check, { size: "16px", color: utils_1.parseThemePath(toggleCheckColor, theme, colors_1.colors.WHITE), name: "check" }))),
            label && !labelBefore && (React.createElement(Label, { htmlFor: id ? id : label, labelBefore: labelBefore, labelColor: labelColor, disabled: disabled }, label))));
    };
    return AXSSwitch;
}(React.Component));
exports.AXSSwitch = AXSSwitch;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=axsswitch.js.map